import React from "react";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";

export const PreferencesNoMap = () => {
    return (
        <div className={noMapWrapper}>
            <BrandSearchIcon size="42" wrapperSize="42" wrapperColor="transparent" />
        </div>
    );
};

const noMapWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
import React from "react";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";

export const PreferencesNoMap = () => {
    return (
        <div className={noMapWrapper}>
            <BrandSearchIcon size="42" wrapperSize="42" wrapperColor="transparent" />
        </div>
    );
};

const noMapWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
